import React, { useRef, useState } from "react"
import ReactPlayer from "react-player"

interface Props {
  url: string
  onVideoFinish?: VoidFunction
  mediaInterest: boolean //pass true if user has already clicked the play button once
  onPlayClicked?: VoidFunction
}

enum State {
  Loading,
  Ready,
  Playing,
}

export const VideoPlayer: React.FC<Props> = (props) => {
  const { url, onVideoFinish, mediaInterest, onPlayClicked } = props
  const [state, setState] = useState(
    mediaInterest ? State.Playing : State.Loading
  )
  const ref = useRef<ReactPlayer>(null)

  const handleReady = () => {
    if (state !== State.Playing) {
      setState(State.Ready)
    }
  }

  const handlePlay = () => {
    setState(State.Playing)
    if (onPlayClicked) {
      onPlayClicked()
    }
  }

  return (
    <div style={{ position: "relative" }}>
      <ReactPlayer
        width="100%"
        height="100%"
        url={url}
        ref={ref}
        playing={state === State.Playing}
        onEnded={onVideoFinish}
        onPlay={handlePlay}
        onReady={handleReady}
      />
      <div
        style={{
          position: "absolute",
          top: 250,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {state === State.Loading && (
          <div style={{ color: "white" }}>Loading...</div>
        )}
        {state === State.Ready && (
          <button onClick={handlePlay} style={{ background: "none" }}>
            <img
              src={process.env.PUBLIC_URL + "/images/play_circle.svg"}
              alt="play"
            />
          </button>
        )}
      </div>
    </div>
  )
}
